import React from 'react'
import { useSelector } from 'react-redux'

import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';

import TenantEcocontrols from './TenantEcocontrols.js'
import EcocontrolLogins from './EcocontrolLogins.js'

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'

import _, { get } from 'lodash'

const evt = new Event('customertable_is_dirty');

const useStyles = makeStyles((theme) => ({}))

const BagsAndTokens = () => {
  const auth = useSelector(state => state.auth)

  const [value, setValue] = React.useState('1');  // for tabs

  // switch tabs
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
    <TabContext value={value} style={{'marginLeft': '0', 'paddingLeft':'0', 'marginRight': '0', 'paddingRight':'0'}} >
          <TabList onChange={handleChange} aria-label="Subpages">
            <Tab label="Ecocontrols" value="1" />
            <Tab label="QR Login Attempts" value="2" />
          </TabList>

        <TabPanel value="1" style={{'marginLeft':'0', 'paddingLeft':'0', 'marginRight': '0', 'paddingRight':'0'}} >
          <TenantEcocontrols />
        </TabPanel>

        <TabPanel value="2" style={{'marginLeft':'0', 'paddingLeft':'0', 'marginRight': '0', 'paddingRight':'0'}} >
          <EcocontrolLogins />
        </TabPanel>
    </TabContext>

    </>
  )
}

export default BagsAndTokens
